// extracted by mini-css-extract-plugin
module.exports =  {"FeaturedButton":"SGLsls0jcKF9b_TO2Qev"};